/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'sag-ui-radio',
  template: `
    <div class="flex items-center">
      <input
        type="radio"
        [id]="id"
        type="radio"
        [attr.name]="name"
        [checked]="checked"
        [disabled]="disabled"
        [required]="required"
        [value]="value"
        [attr.aria-disabled]="disabled"
        [attr.aria-labelledby]="ariaLabelledby || id"
        [attr.aria-label]="ariaLabel"
        [attr.aria-describedby]="ariaDescribedby"
        (change)="onChange($event)"
        (click)="click.emit($event)"
        (focus)="focus.emit($event)"
        (blur)="onTouched(); blur.emit($event)"
        sag-ui-radio
      />
      <label [for]="id" sag-ui-radio-label class="pl-2"><ng-content></ng-content></label>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent implements ControlValueAccessor, Validator {
  @Input() id: string = this.randomId();
  @Input() checked = false;
  @Input() disabled = false;
  @Input() name: string | null = null;
  @Input() value: any;
  @Input() required = false;

  // Accessibility inputs
  @Input() ariaLabel: string | null = null;
  @Input() ariaLabelledby: string | null = null;
  @Input() ariaDescribedby: string | null = null;

  @Output() click = new EventEmitter<Event>();
  @Output() focus = new EventEmitter<Event>();
  @Output() blur = new EventEmitter<Event>();
  @Output() change = new EventEmitter<Event>();

  constructor(private cd: ChangeDetectorRef) {}

  onChangeEvent = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.checked = value == this.value;
    this.cd.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChangeEvent = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cd.markForCheck();
  }

  onChange(event: Event): void {
    event.stopPropagation();
    const input = event.target as HTMLInputElement;

    let changed: any;
    if (typeof this.value === 'boolean') {
      changed = input.value === 'true';
    } else {
      changed = input.value;
    }

    this.change.emit(changed);
    this.onChangeEvent(changed);
  }

  validate(_: AbstractControl): ValidationErrors | null {
    return null;
  }

  private randomId(): string {
    return Math.random().toString(36).substring(2);
  }
}
